export default function getEventTargetValue(target) {
  return target.type === 'checkbox' ? target.checked : target.value;
}
